import { navigationBarsGetters } from '@/store/modules/navigationBars/routines'

export default {
  [navigationBarsGetters.LEFT_HAND_SIDE_BAR]: state => state.leftHandSideBar,
  [navigationBarsGetters.RIGHT_HAND_SIDE_BAR]: state => state.rightHandSideBar
}
